import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, message, Row, Col } from 'antd';
import { UserOutlined, LockOutlined, ShopOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const onFinish = async (values: { email: string; password: string }) => {
    setLoading(true);
    try {
      const userData = await login(values.email, values.password);
      message.success('Giriş başarılı!');
      
      // Kullanıcı bilgilerini kontrol et
      // Alt kullanıcılar için isActive kontrolü yapılmaz (zaten backend'de kontrol ediliyor)
      if (userData && ('isActive' in userData ? userData.isActive : true)) {
        navigate('/panel');
      } else {
        navigate('/');
      }
    } catch (error: any) {
      message.error(error.message || 'Giriş yapılamadı. E-posta ve şifrenizi kontrol edin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, #FF6B35 0%, #FF8E53 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <Row justify="center" style={{ width: '100%' }}>
        <Col xs={24} sm={20} md={16} lg={12} xl={8}>
          <Card 
            style={{ 
              borderRadius: '12px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
            }}
            bodyStyle={{
              padding: '24px'
            }}
          >
            <div style={{ textAlign: 'center', marginBottom: '32px' }}>
              <ShopOutlined style={{ fontSize: '48px', color: '#FF6B35', marginBottom: '16px' }} />
              <Title level={2} style={{ color: '#333', margin: 0 }}>
                YakıtGo
              </Title>
              <Text type="secondary" style={{ fontSize: '16px' }}>
                İstasyon Sahipleri Paneli
              </Text>
            </div>

            <Form
              name="login"
              onFinish={onFinish}
              autoComplete="off"
              size="large"
            >
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: 'E-posta adresinizi girin!' },
                  { type: 'email', message: 'Geçerli bir e-posta adresi girin!' }
                ]}
              >
                <Input 
                  prefix={<UserOutlined />} 
                  placeholder="E-posta adresiniz"
                  style={{ color: '#333333' }}
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[
                  { required: true, message: 'Şifrenizi girin!' },
                  { min: 6, message: 'Şifre en az 6 karakter olmalıdır!' }
                ]}
              >
                <Input.Password 
                  prefix={<LockOutlined />} 
                  placeholder="Şifreniz"
                  style={{ color: '#333333' }}
                />
              </Form.Item>

              <Form.Item>
                <Button 
                  type="primary" 
                  htmlType="submit" 
                  loading={loading}
                  style={{ 
                    width: '100%',
                    height: '48px',
                    background: '#FF6B35',
                    borderColor: '#FF6B35',
                    borderRadius: '8px',
                    fontSize: '16px',
                    fontWeight: '600'
                  }}
                >
                  Giriş Yap
                </Button>
              </Form.Item>
            </Form>

            <div style={{ textAlign: 'center', marginTop: '24px' }}>
              <Text type="secondary">
                Hesabınız yok mu?{' '}
                <Button 
                  type="link" 
                  onClick={() => navigate('/register')}
                  style={{ color: '#FF6B35', padding: 0, fontWeight: 'bold' }}
                >
                  Kayıt olun
                </Button>
              </Text>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Login;
